export default __webpack_public_path__ + "static/media/3.b78a7dc6.png";